import * as React from 'react';
import Button from '../Button';
import Icon from '../Icon';

export interface IDeleteModalProps {
  title: string | React.ReactNode;
  onClose: () => void;
  onCancel: () => void;
  onDelete: () => void | Promise<any>;
  deleteButtonText: string;
  cancelButtonText: string;
}

const DeleteModal = (props: IDeleteModalProps) => {
  const [loading, setLoading] = React.useState(false);

  const handleDelete = () => {
    const result = props.onDelete();
    if (result && typeof result.then === 'function') {
      setLoading(true);

      result.then(() => {
        setLoading(false);
        props.onClose();
      });
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-20 has-background-gray-body p-6">
      <div className="has-background-white flex-none w-full max-w-2xl text-center p-12">
        <Icon
          name="alert-triangle"
          className="w-12 h-12 has-text-danger m-4"
        />
        <div className="f2 font-semibold">{props.title}</div>

        <div className="mt-12">
          <Button
            type="button"
            color="light"
            className="mx-2"
            size="large"
            onClick={props.onCancel}
          >
            <Icon name="arrow-left" className="mr-2" />
            {props.cancelButtonText}
          </Button>
          <Button
            type="button"
            color="danger"
            className="mx-2"
            size="large"
            loading={loading}
            onClick={handleDelete}
          >
            {props.deleteButtonText}
            <Icon name="cross" className="ml-2" />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModal;



// WEBPACK FOOTER //
// ./src/components/DeleteModal/index.tsx